<template>
  <div>
    <div class="title">如何取消订单？</div>
<div class="content-info">
	<p class="txt1">商户可以自行操作取消整个订单，系统暂不支持取消单品，具体操作如下：<br/>
 进入商城首页，点击“我的”，可以在“我的订单”模块点击“查看全部订单”，从而进入我的订单列表，点击“取消订单”按钮，即可取消整个订单；</p>
	<ul>
		<li><img src="https://img-oss.yunshanmeicai.com/cfile/10ecb07c2beb64ce0238c515858a2e73.png"></li>
		<li><img src="https://img-oss.yunshanmeicai.com/cfile/799a2d73a1e2f72ae42cfb6e943e7270.png"></li>
		<li><img src="https://img-oss.yunshanmeicai.com/cfile/46f1e47788cd7d9aaa165e3bcdab1be6.png"></li>
		<li><img src="https://img-oss.yunshanmeicai.com/cfile/1ce8a638a0bf41bdd98800d26471c2b7.png"></li>
	</ul>
</div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
